import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  loading: false,
  error: null,
  papers: [],
  papersList: [],
};

const additionalpapersSlice = createSlice({
  name: "additionalpapers",
  initialState,
  reducers: {
    loadAdditionalPapersRequested(state, action: PayloadAction<any>) {
      state.additionalPapersLoading = true;
      state.error = null;
    },
    loadAdditionalpapersSuccess(state, action: PayloadAction<any>) {
      state.additionalPapersLoading = false;
      state.additionalPapers = action.payload?.result?.results;
      state.paginationOption = {
        page: action.payload?.result?.page,
        pageSize: action.payload?.result?.pageSize,
        totalItems: action.payload?.result?.totalItems,
        numberOfPages: action.payload?.result?.numberOfPages,
      };
    },
    loadAdditionalPapersFail(state, action: PayloadAction<{}>) {
      state.additionalPapersLoading = false;
      state.error = action.payload;
    },

    storeAdditionalPaperRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    storeAdditionalPaperSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = null;
      state.storeAdditionalPaper = action.payload;
    },
    storeAdditionalPaperFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    updateAdditionalPaperRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    updateAdditionalPaperSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.updateadditionalPaper = action.payload;
    },
    updateAdditionalPaperFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    archiveAdditionalPaperRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    archiveAdditionalPaperSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = null;
      state.archiveAdditionalPaper = action.payload;
    },
    archiveAdditionalPaperFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    deleteAdditionalPaperRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    deleteAdditionalPaperSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.deleteAdditionalPaper = action.payload;
    },
    deleteAdditionalPaperFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loadAdditionalPapersRequested,
  loadAdditionalpapersSuccess,
  loadAdditionalPapersFail,
  storeAdditionalPaperRequested,
  storeAdditionalPaperSuccess,
  storeAdditionalPaperFail,
  updateAdditionalPaperRequested,
  updateAdditionalPaperSuccess,
  updateAdditionalPaperFail,
  archiveAdditionalPaperRequested,
  archiveAdditionalPaperSuccess,
  archiveAdditionalPaperFail,
  deleteAdditionalPaperRequested,
  deleteAdditionalPaperSuccess,
  deleteAdditionalPaperFail,
} = additionalpapersSlice.actions;

export default additionalpapersSlice.reducer;
